export const getStyled = (theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    maxWidth: '90%',
  },

  mainHeader: {
    display: 'flex',
    margin: '5px 20px',
    justifyContent: 'center',
  },

  mainPaper: {
    display: 'flex',
    flexDirection: 'row',
    padding: theme.spacing(1),
    paddingBottom: 0,

    flexWrap: 'nowrap',
    overflowX: 'auto',
    ...theme.custom.scrollbarStyles,
    alignItems: 'flex-start',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#15202B',
    border:
      theme.palette.mode === 'light'
        ? '1px solid #eaeaea'
        : '1px solid #444444',
    height: '85vh',
  },

  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: 100,
  },

  chatPapper: {
    display: 'flex',
    height: '100%',
  },

  contactsHeader: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0px 6px 6px 6px',
  },

  title: {
    color: theme.palette.primary.main,
    fontSize: 24,
  },
});
